import { useSelector } from '@bonanza-social/toolkit/state';
import { memo } from 'react';
import { Styles, ViewStyle } from '@bonanza-social/moonlight';
import { selectIsNewLoyalty } from '../../state';
import LegacyStautsHeaderItem from '../legacy/StatusHeaderItem/StatusHeaderItem';
import StatusHeaderItem from './StatusHeaderItem';

function StatusHeaderItemWrapper(props: Styles<ViewStyle>) {
  const isNewLoyalty = useSelector(selectIsNewLoyalty);

  return isNewLoyalty ? (
    <StatusHeaderItem {...props} />
  ) : (
    <LegacyStautsHeaderItem {...props} />
  );
}

export default memo(StatusHeaderItemWrapper);
